import { I18nThemed } from 'interfaces/mixins';
import { DNode } from '@dojo/framework/core/interfaces';
import { v, w } from '@dojo/framework/core/vdom';
import { TextArea } from '@dojo/widgets/text-area';
import { FormTextField } from '../interfaces';

export interface FormTextProperties extends FormTextField {}

export class FormText extends I18nThemed<FormTextProperties> {
	valid: boolean | undefined;

	protected render(): DNode {
		const { title: label, fgRows: rows, id: name, required, placeholder, formdata } = this.properties;
		if (this.valid === undefined) {
			this.valid = !required;
		}
		if (formdata[name] === undefined || formdata[name] === null) {
			formdata[name] = '';
		}
		const textarea = w(
			TextArea,
			{
				key: name,
				name,
				rows: +rows,
				placeholder,
				value: formdata[name],
				columns: 60,
				required,
				valid: this.valid,
				onValue: (value: string) => {
					formdata[name] = value;
					this.valid = (required && value.length > 3) || !required;
					this.invalidate();
				}
			},
			[{ label }]
		);
		return v('div', {}, [textarea]);
	}
}
